// extracted by mini-css-extract-plugin
export var column = "footer-module--column--0b60c";
export var copy = "footer-module--copy--5e14d";
export var logo = "footer-module--logo--9ab9c";
export var logoImage = "footer-module--logoImage--63048";
export var nav = "footer-module--nav--d5304";
export var wrapper = "footer-module--wrapper--88066";